import React, { useEffect, useLayoutEffect, useState } from "react";
import { ScrollView, Text, View, TouchableOpacity } from "react-native";
import { If, Then } from "react-if";
import { useRoute, useNavigation } from "@react-navigation/native";
import AsyncStorage from "@react-native-async-storage/async-storage";
import CardsMyTokensWallet from "../../components/CardsMyTokensWallet";
import CardsTransactionsWallet from "../../components/CardsTransactionsWallet";
import ScreenLoader from "../../components/ScreenLoader";
import api from "../../services/api";
import CardsMyCertificatesWallet from "../../components/CardsMyCertificatesWallet";
import styles from "./styles";
import { FormattedMessage } from "react-intl";
import WalletTransactionButtons from "../../components/WalletTransactionButtons";
import HeaderTabs from "../../components/HeaderTabs";
import Header from "../../components/Header";

const Wallet = ({ openTransaction }) => {
  const [activeButton, setActiveButton] = useState(0);
  const setPageTab = (index) => {
    setActiveButton(index);
  };

  const [saldo, setSaldo] = useState(0);
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [isEndorser, setIsEndorser] = useState(false);
  const route = useRoute();
  const navigation = useNavigation();

  useEffect(() => {
    const tabIndex = route?.params?.tabIndex;
    if (tabIndex !== undefined) {
      setPageTab(tabIndex);
    }
  }, [route.params]);

  useLayoutEffect(() => {
    const endorser = route?.params?.endorser;
    if (endorser !== undefined) {
      setIsEndorser(endorser);
      console.log("Setando isEndorser: " + endorser);
    }
  }, [route]);

  useEffect(() => {
    getBalanceCoin();
    if (openTransaction) {
      setPageTab(1);
    }
  }, [openTransaction]);

  useEffect(() => {
    const tabIndex = route?.params?.tabIndex;
    if (tabIndex !== undefined) {
      setPageTab(tabIndex);
    }
  }, [route.params]);

  const getBalanceCoin = async () => {
    const token = await AsyncStorage.getItem("JWT_TOKEN");
    setLoading1(true);
    api
      .get("balanceGpxcoin", { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => {
        if (res.data.balance[0].available_balance) {
          setSaldo(res.data.balance[0].available_balance);
        } else {
          setSaldo(res.data.balance[0].saldo);
        }
        setLoading1(false);
      })
      .catch((error) => {
        setLoading1(false);
        console.log("erro2", error);
      });
  };

  return (
    <ScrollView>
      <ScreenLoader loading={loading1 || loading2 || loading3} />
      <View style={styles.container}>
        <HeaderTabs title={<FormattedMessage id="wallet.titulo" />} />
        <View style={styles.headerContainer}>
          <Header />
        </View>

        <View>
          <If condition={!isEndorser}>
            <Then>
              <WalletTransactionButtons />
            </Then>
          </If>
        </View>

        <View style={styles.containerBtnsCarteira}>
          <TouchableOpacity onPress={() => setPageTab(0)}>
            <Text
              style={[
                styles.tabText,
                activeButton === 0 && styles.activeButtonText,
              ]}
            >
              <FormattedMessage id="wallet.btnAtivosAmbientais" />
            </Text>
          </TouchableOpacity>
          <TouchableOpacity onPress={() => setPageTab(1)}>
            <Text
              style={[
                styles.tabText,
                activeButton === 1 && styles.activeButtonText,
              ]}
            >
              <FormattedMessage id="wallet.btnTransacoes" />
            </Text>
          </TouchableOpacity>
          <TouchableOpacity onPress={() => setPageTab(2)}>
            <Text
              style={[
                styles.tabText,
                activeButton === 2 && styles.activeButtonText,
              ]}
            >
              <FormattedMessage id="wallet.btnCertificados" />
            </Text>
          </TouchableOpacity>{" "}
          <TouchableOpacity
            onPress={() => navigation.navigate("AssetsOwnership")}
          >
            <Text
              style={[
                styles.tabText,
                activeButton === 3 && styles.activeButtonText,
              ]}
            >
              <FormattedMessage id="wallet.btnExtratoAtivos" />
            </Text>
          </TouchableOpacity>
        </View>

        <View style={styles.contentPageTab}>
          {activeButton === 0 && (
            <CardsMyTokensWallet
              saldoGPX={saldo}
              showTradeButtons={!isEndorser}
              loading={(value) => setLoading2(value)}
            />
          )}
          {activeButton === 1 && (
            <CardsTransactionsWallet
              openFirst={openTransaction}
              loading={(value) => setLoading3(value)}
            />
          )}
          {activeButton === 2 && <CardsMyCertificatesWallet />}
        </View>
      </View>
    </ScrollView>
  );
};

export default Wallet;
